import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    title: 'New Task',
    executeLabel: '1. Execute',
    whenLabel: '2. When',
    paymentLabel: '3. Payment',
    confirmLabel: '4. Confirm',
  },
};
